// UTM Parameter Management
export interface UTMParams {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term?: string;
  utm_content?: string;
}

// Capture UTM parameters from URL and persist in sessionStorage
export const captureUTMParams = (): UTMParams => {
  const urlParams = new URLSearchParams(window.location.search);
  
  const utmParams: UTMParams = {
    utm_source: urlParams.get('utm_source') || sessionStorage.getItem('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || sessionStorage.getItem('utm_medium') || '',
    utm_campaign: urlParams.get('utm_campaign') || sessionStorage.getItem('utm_campaign') || '',
    utm_term: urlParams.get('utm_term') || sessionStorage.getItem('utm_term') || '',
    utm_content: urlParams.get('utm_content') || sessionStorage.getItem('utm_content') || ''
  };
  
  // Store in sessionStorage for persistence across page navigation
  if (utmParams.utm_source) sessionStorage.setItem('utm_source', utmParams.utm_source);
  if (utmParams.utm_medium) sessionStorage.setItem('utm_medium', utmParams.utm_medium);
  if (utmParams.utm_campaign) sessionStorage.setItem('utm_campaign', utmParams.utm_campaign);
  if (utmParams.utm_term) sessionStorage.setItem('utm_term', utmParams.utm_term);
  if (utmParams.utm_content) sessionStorage.setItem('utm_content', utmParams.utm_content);
  
  return utmParams;
};

// Get stored UTM parameters
export const getStoredUTMParams = (): UTMParams => {
  return {
    utm_source: sessionStorage.getItem('utm_source') || '',
    utm_medium: sessionStorage.getItem('utm_medium') || '',
    utm_campaign: sessionStorage.getItem('utm_campaign') || '',
    utm_term: sessionStorage.getItem('utm_term') || '',
    utm_content: sessionStorage.getItem('utm_content') || ''
  };
};

// Clear UTM parameters from storage
export const clearUTMParams = () => {
  sessionStorage.removeItem('utm_source');
  sessionStorage.removeItem('utm_medium');
  sessionStorage.removeItem('utm_campaign');
  sessionStorage.removeItem('utm_term');
  sessionStorage.removeItem('utm_content');
};

// Format UTM params for form submission
export const formatUTMForSubmission = (params: UTMParams): Record<string, string> => {
  const formatted: Record<string, string> = {};
  
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      formatted[key] = value;
    }
  });
  
  return formatted;
};